export const toUserInputConfirmInfo = (state = {}, action) => {
    switch (action.type) {
        case "TO_USERINPUTCONFIRM_INFO": {
            return {
                hotelId: action.payload.toUserInputConfirmInfo.hotelId,
                hotelName: action.payload.toUserInputConfirmInfo.hotelName,
                planId: action.payload.toUserInputConfirmInfo.planId,
                planName: action.payload.toUserInputConfirmInfo.planName,
                roomTypeId: action.payload.toUserInputConfirmInfo.roomTypeId,
                roomTypeName: action.payload.toUserInputConfirmInfo.roomTypeName,
                paymentId: action.payload.toUserInputConfirmInfo.paymentId,
                paymentMethod: action.payload.toUserInputConfirmInfo.paymentMethod,
                paymentPrice: action.payload.toUserInputConfirmInfo.paymentPrice,
                roomSum: action.payload.toUserInputConfirmInfo.roomSum,
                representInfo: action.payload.toUserInputConfirmInfo.representInfo,
                roomInfo: action.payload.toUserInputConfirmInfo.roomInfo,
                checkInDate: action.payload.toUserInputConfirmInfo.checkInDate,
                checkOutDate: action.payload.toUserInputConfirmInfo.checkOutDate
            };
        }
        default: {
            return state;
        }
    }
};
